import { dealApi, dealQueryKeys } from "service/crm/api/deal";
import { useActivityFeed } from "../useActivityFeed";


export const useDealActivity = (dealUuid: string, pageSize = 20) =>
  useActivityFeed(
    dealQueryKeys.activities(dealUuid),
    (page) => dealApi.getDealActivities(dealUuid, page, pageSize, "ALL_ACTIVITIES"),
    !!dealUuid,
  );